// extracted by mini-css-extract-plugin
export default {"container":"ProfileForm_container__RfNyR","card":"ProfileForm_card__xnns-","title":"ProfileForm_title__De6l+"};